import React, {useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {useHistory, useLocation, useParams} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {hideLoading, showLoading} from '../../../redux/actions/loadingActions';
import { setLanguageId, setUiLanguageId } from '../../../redux/actions/baseActions';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './WebPaymentSuccessPage.scss';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

function sendSuccessMessage() {
    const message = { type: 'SUCCESSFUL_PAYMENT', success: true };
    window.parent.postMessage(message, '*');
}

const WebPaymentSuccessPage = (props) => {
    const { showLoading, hideLoading, t, setLanguageId, setUiLanguageId } = props;
    const {branchId, orderId} = useParams();
    const history = useHistory();
    const query = useQuery();
    const localeParam = query.get('locale');

    useEffect(() => {
        setTimeout(() => {
            hideLoading();
            sendSuccessMessage();
        }, 500);

    }, []);

    useEffect(() => {
        setLanguageId(localeParam === 'en' ? 1 : 2);
        setUiLanguageId(localeParam === 'en' ? 1 : 2);
    }, [localeParam]);

    const onOkClick = () => {
        // history.push(`/${branchId}/invoice/${orderId}`);
        window.location = `/${branchId}/invoice/${orderId}`;
    };

    return (
        <div className="payment-success-page">
            <div className="success-message">
                {t('order.submit.success_title')}
            </div>

            <div className="info-icon">
                <FontAwesomeIcon icon="check-circle" />
            </div>

            <div className="btn ok-button" onClick={ onOkClick }>
                {t('payment_success_page.accept_btn')}
            </div>
        </div>
    );
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            showLoading,
            hideLoading,
            setLanguageId,
            setUiLanguageId
        },
        dispatch,
    );

export default withTranslation()(connect(null, mapDispatchToProps)(WebPaymentSuccessPage));
